import { Button as _Button } from "@mui/material";

import { Colors } from "../constants/colors";

type ButtonProps = {
  value: string;
  gradient?: boolean;
  fontSize?: number;
  onClick?: () => void;
  type?: "button" | "submit" | "reset";
  disabled?: boolean;
  variant?: any;
};

const Button = ({
  value,
  onClick,
  gradient = false,
  fontSize = 17,
  type,
  disabled,
  variant,
}: ButtonProps) => {
  return (
    // eslint-disable-next-line react/jsx-pascal-case
    <_Button
      onClick={onClick}
      disabled={disabled}
      style={{
        background: Colors.primary,
        fontWeight: 300,
        fontSize,
        width: "100%",
        textTransform: "capitalize",
      }}
      variant={variant || "contained"}
      type={type || "button"}
    >
      {value}
    </_Button>
  );
};

export default Button;
